import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
// 创建 axios 实例
const service = axios.create({
  // baseURL: 'https://asset-management-api.rainchapter.com',
  baseURL: 'https://asset-management-api.rainchapter.com',
  // baseURL: process.env.VUE_APP_BASE_API || '', // api 的基础url
  timeout: 60000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 写一个简单的防抖函数
function debounce(fn, delay) {
  let timer = null
  return function() {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn()
    }, delay)
  }
}
const debounceFn = debounce(() => {
  // Message({
  //   message: '登录已过期，请重新登录',
  //   type: 'error',
  //   duration: 5 * 1000
  // })
  localStorage.removeItem('token')
  router.replace('/login')
}, 1000)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 这里可以根据后端返回的数据结构做相应的处理
    const {code, message } = res
    if (code == '10005' && message == '未登录') {
      debounceFn()
    }
    return res
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service 